import styles from "./Ranks.module.scss";
// Common components
import ModalWrapper from "../../common/others/ModalWrapper";
// Sub components
import Rank from "./sub-components/Rank";
// Utils
import ranksConfig from "../../../utils/configs/ranks";

const RanksModal = ({ displayStatus, toggle }) => {
  return (
    <ModalWrapper
      displayStatus={displayStatus}
      toggle={toggle}
      title={"سطوح کاربری"}
      className={styles["ranks-modal"]}
    >
      <p className={styles.tip}>
        با توجه به حجم معاملات سه ماه اخیر کاربر، کارمزد معاملات طبق جدول زیر به
        صورت پلکانی محاسبه می‌گردد:
      </p>

      <div className={styles.ranks}>
        {ranksConfig.map((item) => (
          <Rank key={item.rank} data={item} />
        ))}
      </div>
    </ModalWrapper>
  );
};

export default RanksModal;
